import { Button, FormLabel, Skeleton, Stack } from '@mui/material';
import React, { useMemo } from 'react';
import TiptapEditor from '../TiptapEditor';
import { EMPTY_HTML } from '@/utils/emailHelper';
import { useGetUserSignatureQuery } from '@/features/user/userApi';

const SignatureEditor = ({ url, value, setValue, handleSave, disabled, showLabel = true }) => {
	const { data: fetchedHtml, isLoading, isFetching } = useGetUserSignatureQuery({ url });
	const html = fetchedHtml ?? value ?? EMPTY_HTML;
	const isLoadingHtml = isLoading || isFetching;
	return (
		<Stack sx={{ minHeight: '200px' }} spacing={2}>
			{showLabel && <FormLabel>Email Signature</FormLabel>}

			{isLoadingHtml ? (
				<Skeleton variant="rectangular" height={200} animation="wave" />
			) : (
				<TiptapEditor
					value={html}
					onChange={setValue}
					disabled={disabled}
					config={{
						toolbar: {
							user: { showSignature: false, show: true },
							brokerage: { show: true },
							deal: { show: false },
							client: { show: false },
							image: { show: true },
							align: { show: true },
							table: { show: true },
						},
					}}
				/>
			)}

			<Stack direction="row" justifyContent="flex-end">
				<Button disabled={disabled || isLoading} variant="contained" onClick={handleSave}>
      Save Signature
				</Button>
			</Stack>
		</Stack>

	);
};

export default SignatureEditor;
